import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from 'src/app/shared/_helpers/authentication.service';
import { finalize } from 'rxjs/operators';
import { LoadingService } from '../loading-spinner/loading.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    private _totalRequests = 0;
    constructor(private _authenticationService: AuthenticationService, private _loadingService: LoadingService) { }
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this._totalRequests++;
        this._loadingService.setHttpProgressStatus(true);
        const currentUser = this._authenticationService.currentUserDataValue;
        if (currentUser && currentUser.token) {
            request = request.clone({
                setHeaders: {
                    'X-Access-Token': currentUser.token,
                    'X-Account-Type': currentUser.accountType.toString()
                }
            });
        }
        return next.handle(request).pipe(
            finalize(() => {
                this._totalRequests--;
                if (this._totalRequests === 0) {
                    this._loadingService.setHttpProgressStatus(false);
                }
            })
        );
    }
}
